module.exports = __webpack_public_path__ + "static/media/sample.fcf68321.PNG";